<!--  This first div is here to force the icon picker to
      assume the full amount of space it will end up
      consuming when all icons are loaded, without yet
      actually loading the icons, because the process
      of actually loading the icons causes Angular to
      hang for a bit. So instead, we render this space
      full of "empty" icons, then ngAfterViewInit sets
      this.ready to true, and then the hanging begins,
      but at least it's hanging with a spinner and a
      full-size icon-picker container present on-screen. -->
@if (!ready) {
  <div class="icons">
    <div class="spinner">
      <motn-spinner></motn-spinner>
    </div>
    @for (option of options; track option) {
      <div class="icon"></div>
    }
  </div>
}

@if (ready) {
  <div class="icons">
    @for (option of options; track option) {
      <div 
        [ngClass]="{'icon': 1, 'selected': option === icon}"
        (click)="pick(option)"
      >
        <i [ngClass]="['fa-regular', 'fa-'+option]"></i>
      </div>
    }
  </div>
}
